"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculatePosition;

var _documentOffset = _interopRequireDefault(require("document-offset"));

function calculatePosition(root, picker, minOffset) {
  var docH = window.document.body.offsetHeight,
      docW = window.document.body.offsetWidth,
      pickerHeight = picker === null || picker === void 0 ? void 0 : picker.offsetHeight,
      pickerReservedHeight = pickerHeight + minOffset,
      offset = (0, _documentOffset["default"])(root),
      availTop = offset.top,
      availBottom = docH - offset.top - (root === null || root === void 0 ? void 0 : root.offsetHeight),
      position = {};

  if (availBottom < pickerReservedHeight && availTop >= pickerReservedHeight) {
    position.bottom = 'calc(100% + 2px)';
    position.top = 'auto';
    position.transformOrigin = 'left bottom';
  } else {
    position.top = 'calc(100% + 2px)';
    position.bottom = 'auto';
    position.transformOrigin = 'left top';
  } // DP width + 18


  if (docW - offset.left - 290 <= 0) {
    position.left = 'auto';
    position.right = 0;
  }

  return position;
}